import { jsx } from 'react/jsx-runtime';
import { IconBase } from '../../icon-base/index.js';

const CheckmarkBold = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("path", { d: "M8,19.1l-7-7l2.5-2.5L8,14L18.1,3.8l2.5,2.5L8,19.1z" }), iconName: "down-caret", viewBox: "0 0 21.6 21.6" })));
CheckmarkBold.displayName = 'VDS_Icon';

export { CheckmarkBold as default };
